<h1 mat-dialog-title class="pt-2 text-center"> Ajout de mesures</h1>
<div mat-dialog-content class="p-0">
    <div class="container no-gutters">

        <div class="row m-0">
            <mat-form-field class="col">
                <mat-select placeholder="Plans" [(ngModel)]="SelectedMap">
                    @for (map of AreaMapList; track map; let i = $index) {
                    <mat-option [value]="map">
                        {{ map.Legend }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="row m-1">
            <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
                Annuler
            </button>
            <button appPreventDoubleClick class="col ms-1" mat-raised-button color="primary" (throttledClick)="finish()">
                Ajouter
            </button>
        </div>
    </div>
</div>